import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-phone-paused",
  templateUrl: "./med-icon-phone-paused.component.html",
})
export class MedIconPhonePausedComponent extends SvgMixinComponent {}
